import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DevolucaoComponent } from './devolucao.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PoModule } from '@po-ui/ng-components';
import { PoPageDynamicEditModule, PoPageDynamicTableModule } from '@po-ui/ng-templates';
import { DevolucaoEditComponent } from './devolucao-edit/devolucao-edit.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    PoModule,
    PoPageDynamicTableModule,
    PoPageDynamicEditModule,
  ],
  declarations: [DevolucaoComponent, DevolucaoEditComponent]
})
export class DevolucaoModule { }
